import React from 'react';
import { Typography } from '@sm/wds-react';
import { Card } from '@wds/card';
import { Box } from '@wds/box';
import { withWebAssetsTheme } from '../../theme';
import useStyles from './useStyles';

export type ClientErrorProps = {
  openingMessage: string;
  errorTitle: string;
  titularElementTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div';
  children?: React.ReactNode;
  className?: string;
  testId?: string;
};

// Exported as a named-component for use without ThemeProvider
export function ClientError({
  openingMessage,
  errorTitle,
  titularElementTag = 'p',
  children,
  className,
  testId = 'ClientError',
}: ClientErrorProps) {
  const { wrapper, cardWrapper, title } = useStyles();
  return (
    <div className={wrapper} data-testid={testId}>
      <div className={className}>
        <Typography variant="pageTitle" align="center">
          {openingMessage}
        </Typography>
        <div className={cardWrapper}>
          <Box>
            <Card>
              <Box p={1}>
                <Typography
                  component={titularElementTag}
                  variant="sectionTitle"
                  align="center"
                  className={title}
                >
                  {errorTitle}
                </Typography>
              </Box>
              {children}
            </Card>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default withWebAssetsTheme(ClientError);
